'use client'

import { Box } from '@mui/material'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { useLocale, useTranslations } from 'next-intl'

import { useDestinationContext } from '@/src/contexts'

const DestinationBreadcrumbs = () => {
    const { destinationData: { sections } } = useDestinationContext()
    const cityName = sections.hero?.cityName
    const locale = useLocale()
    const t = useTranslations('common')

    if (!cityName) return null

    return (
        <Box sx={{ mb: 2 }}>
            <Breadcrumbs separator="›" aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href={`/${locale}`}>
                    {t('home')}
                </Link>
                <Link underline="hover" color="inherit" href={`/${locale}/flights`}>
                    {t('flights')}
                </Link>
                <Typography sx={{ color: 'text.primary' }}>
                    {cityName}
                </Typography>
            </Breadcrumbs>
        </Box>
    )
}

export default DestinationBreadcrumbs
